import { render, staticRenderFns } from "./cardinfo.vue?vue&type=template&id=529e3f2a&scoped=true&"
import script from "./cardinfo.vue?vue&type=script&lang=js&"
export * from "./cardinfo.vue?vue&type=script&lang=js&"
import style0 from "./cardinfo.vue?vue&type=style&index=0&id=529e3f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e3f2a",
  null
  
)

export default component.exports